import { Component } from '@angular/core';
import { CustomizerSettingsService } from '../../../components/customizer-settings/customizer-settings.service';

@Component({
    selector: 'app-signin-signup',
    templateUrl: './signin-signup.component.html',
    styleUrls: ['./signin-signup.component.scss']
})
export class SigninSignupComponent {

    hide = true;

    constructor(
        public themeService: CustomizerSettingsService
    ) {}

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

}
